<template>
    <div>
        <template v-if="dropdown">
            <button class="dropdown-item" :disabled="comunicando" v-if="tem_etiqueta" @click="etiqueta_servidor_impressao()">
                Integração/Etiquetas
            </button>
            <slot name="dropamostras"></slot>
        </template>

        <div class="d-flex" v-else>
            <button class="btn btn-outline-secondary d-md-block d-none" :class="canto ? '' : 'ml-2'" v-if="tem_etiqueta" @click="etiqueta_servidor_impressao()" :disabled="comunicando">
                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="comunicando">
                    <span class="sr-only">Loading...</span>
                </div>
                Integração/Etiquetas
            </button>

            <button class="btn btn-outline-secondary d-md-none d-block" :class="canto ? '' : 'ml-2'" v-if="tem_etiqueta" @click="etiqueta_servidor_impressao()" :disabled="comunicando">
                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="comunicando">
                    <span class="sr-only">Loading...</span>
                </div>
                <i class="fas fa-vials" v-else></i>
            </button>

            <button class="btn btn-outline-secondary d-md-block d-none ml-2" :class="canto ? '' : 'ml-2'" v-if="tem_etiqueta" @click="etiqueta_servidor_impressao(true)" :disabled="comunicando">
                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="comunicando">
                    <span class="sr-only">Loading...</span>
                </div>
                Reimprimir Etiquetas
            </button>

            <button class="btn btn-outline-secondary d-md-block d-none ml-2" :class="canto ? '' : 'ml-2'" v-if="tem_etiqueta && $store.state.user.id_usuario == 1" @click="exibir_log()" :disabled="comunicando">
                <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="comunicando">
                    <span class="sr-only">Loading...</span>
                </div>
                Log
            </button>
            
            <template v-if="fila && lista_opcoes_fila.length">
                <div :class="encup ? 'dropup' : 'dropdown'" class="dropdown ml-2">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="comunicando">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="comunicando">
                            <span class="sr-only">Loading...</span>
                        </div>
                        Encaminhar
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" href="#" @click.prevent="encaminhar_fila_outro(adicao)" v-for="(adicao, iax) in lista_opcoes_fila" :key="iax">{{ adicao.st_titulo }}</a>
                    </div>
                </div>
            </template>
        </div>

         <!-- Modal -->
        <div class="modal fade" :id="nome_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Etiqueta</h5>
                        <button type="button" class="close" aria-label="Close" @click="fechar_modal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <az-input   
                            sizing="sm"
                            type="checkbox-group"
                            label="Não imprimir amostras já enviadas"
                            :edicao="amostra_selecionada === null"
                            v-model="block_enviadas" />

                        <div class="mt-1" v-if="horabase && amostra_selecionada === null">
                            <az-input   
                                sizing="sm"
                                type="checkbox-group"
                                label="Imprimir amostras atualizadas"
                                v-model="apenas_atualizadas" />
                        </div>

                        <div class="mt-1" v-if="tem_anat_pat">
                            <az-input   
                                sizing="sm"
                                type="checkbox-group"
                                label="Imprimir etiqueta extra"
                                v-model="etiqueta_extra" />
                        </div>

                        <template v-if="lista_servidor && lista_servidor.length">
                            <div class="form-row mt-3">
                                <div class="col col-6">
                                    <div class="form-control">
                                        <span class="form-check form-check-inline mr-3">
                                            <input class="form-check-input" type="radio" name="etq_epl_pdf" value="E" v-model="tipo_etq">
                                            <label class="form-check-label" for="exampleRadios1">
                                                EPL
                                            </label>
                                        </span>
                                    </div>
                                </div>
                                <div class="col col-6">
                                    <div class="form-control">
                                        <span class="form-check form-check-inline mr-3">
                                            <input class="form-check-input" type="radio" name="etq_epl_pdf" value="P" v-model="tipo_etq">
                                            <label class="form-check-label" for="exampleRadios1">
                                                PDF
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3" v-if="!servidor_impressao_reimprimir">
                                <az-input 
                                    sizing="sm"
                                    type="select"
                                    placeholder="Sem redirecionamento de servidor de impressão"
                                    icon="fa-solid fa-signs-post fa-fw"
                                    optionsMode="aql"
                                    service="rota_etqs.index"
                                    optionsData="id_rota_etq"
                                    v-model="id_rota_etq" />
                            </div>

                            <div class="mt-3">
                                <small class="text-muted">Servidor de Impressão</small>
                            </div>
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" 
                                    :class="servidor_selecionado === isx ? 'active' : ''"
                                    v-for="(serv, isx) in lista_servidor" 
                                    :key="isx" 
                                    @click="servidor_selecionado = isx">
                                    {{ serv }}
                                </button>
                            </div>
                        </template>

                        <!-- Reimpressão / Seleção de Amostras -->
                        <template v-if="servidor_impressao_reimprimir && lista_amostras && lista_amostras.length">
                            <div class="mt-3">
                                <small class="text-muted">Imprimir Amostra</small>
                            </div>
                            <div>
                                <div class="list-group">
                                    <button 
                                        :disabled="apenas_atualizadas"
                                        type="button" 
                                        class="list-group-item list-group-item-action d-flex justify-content-between" 
                                        :class="lista_selecionadas[iax] ? 'active' : ''"
                                        v-for="(amo, iax) in lista_amostras" :key="iax"
                                        @click="selecionar_amostra(iax, amo)">
                                        <!-- @click="iax === amostra_selecionada ? amostra_selecionada = null : amostra_selecionada = iax"> -->
                                        <!-- :class="iax === amostra_selecionada ? 'active' : ''" -->
                                        <div>
                                            {{ amo.st_codigo }} 
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ amo.exames ? amo.exames : amo.st_titulo }}
                                        </div>
                                        <div v-if="amo.tipo_etq">
                                            <a href="#" @click.prevent="selecionar_por_tipo(amo.tipo_etq.search, iax)">
                                                <span class="badge badge-success">
                                                    {{ amo.tipo_etq.search }}
                                                </span>
                                            </a>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </template>

                    </div>

                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <az-input   
                                style="width: 200px;"
                                sizing="sm"
                                type="number"
                                label="Qtd"
                                placeholder="Padrão..."
                                :compact="true"
                                :min="1"
                                :max="99"
                                v-model="in_qtde"
                                v-if="servidor_impressao_reimprimir" />
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary"  @click="etiqueta_servidor_impressao_fechar(true)" v-if="tipo_etq == 'P'">Visualizar</button>
                            <button type="button" class="btn btn-primary ml-1" @click="etiqueta_servidor_impressao_fechar(false)">Imprimir</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <terceiro-log ref="terceiroLogRef" />
    </div>
</template>

<script>
import $ from "jquery";
import _ from 'lodash';
import TerceiroLog from "../../modulos/recepcao/TerceiroLog.vue";
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            dados: null,
            comunicando: false,
            servidor_impressao: null,
            servidor_impressao_reimprimir: true,
            block_enviadas: true, 
            sufixo_modal: "", 
            lista_servidor: [], 
            servidor_selecionado: 0, 
            amostra_selecionada: null, 
            tipo_etq: "P", 
            apenas_atualizadas: false, 
            id_rota_etq: "", 
            exibir_rotas: true, 
            lista_selecionadas: [], 
            etiqueta_extra: false, 
            in_qtde: "", 
        };
    },

    props: ["value", "canto", "dropdown", "pre_integracao", "fila", "horabase", "encup"],

    components: {
        TerceiroLog,
        AzInput
    },

    computed: {
        lista_opcoes_fila: function () { 
            if ( !this.value || !this.value.dt_inicio || ( this.value.dt_inicio >= this.$util.hoje() && ( !this.value.item_status || !this.value.item_status.finalizado ) ) )
                return [];

            if ( !this.value.procedimento || this.value.procedimento.id_especialidade != 2 )
                return [];

            let recep  = this.$util.recepcao();

            if ( !recep || !recep.adicoes )
                return [];

            return recep.adicoes.filter(item => item.st_tipo == 'O');
        },

        tem_etiqueta: function() {
            if (!this.value || !this.value.atendimento) return false;

            if (this.value.atendimento.atendimento_procedimentos_count)
                return true;

            if (this.value.atendimento.lista_terceiro_logs_count ) 
                return true;

            if (!this.value.atendimento.atendimento_procedimentos) 
                return false;

            return this.value.atendimento.atendimento_procedimentos.find(
                item => item.terceiro || item.amostra_atendimento_procedimento
            );
        },

        tem_anat_pat: function() {
            if (!this.value || !this.value.atendimento) return false;

            if (!this.value.atendimento.amostras) 
                return false;

            return this.value.atendimento.amostras.find(
                amo => _.get(amo, 'exames.0.atendimento_procedimento.procedimento.id_classe_procedimento') == 20
            );
        },

        lista_amostras: function () { 
            if (!this.value || !this.value.atendimento || !this.value.atendimento.atendimento_procedimentos) 
                return false;

            let amo_ap = ( this.value.atendimento && this.value.atendimento.amostras ) 
                ? this.value.atendimento.amostras.filter(amo => { 
                        return _.get(amo, 'exames.0.atendimento_procedimento.procedimento.id_classe_procedimento') == 20;
                    })
                    .map(amo => { 
                        let amostra = _.cloneDeep(amo);
                        amostra.exames = ( amo.st_titulo ? amo.st_titulo + ' / ' : '' ) + amo.exames.map(exame => exame.atendimento_procedimento.procedimento.st_sigla).join(', ') 
                        return amostra;
                    })
                : []; 

            let amo_lab = _.map(
                _.groupBy(
                    this.value.atendimento.atendimento_procedimentos.filter(atp => { 
                        return atp.amostra_atendimento_procedimento 
                            && atp.amostra_atendimento_procedimento.amostra
                            && ( atp.procedimento.id_classe_procedimento != 20 );
                    }), 
                    'amostra_atendimento_procedimento.amostra.st_codigo'
                ),
                (exames) => { 
                    let amostra = _.cloneDeep(
                        _.get(exames, '0.amostra_atendimento_procedimento.amostra')
                    );

                    amostra.exames = exames.map(exame => exame.procedimento.st_sigla).join(', ') 

                    return amostra;
                }
            );

            return amo_lab.concat(amo_ap);

        }, 

        nome_modal: function () { 
            return 'etiquetaServidorImpressao' + this.sufixo_modal;
        }
    },

    methods: {
        selecionar_por_tipo (tipo, indice) { 
            this.lista_amostras.forEach( (amo, iax) => { 
                if ( iax === indice ) return;
                if ( amo.tipo_etq && amo.tipo_etq.search == tipo ) { 
                    this.selecionar_amostra(iax, amo);
                }
            });
        },

        selecionar_amostra (iax, amo) { 
            this.$set(this.lista_selecionadas, iax, !this.lista_selecionadas[iax] ? amo : null);
        },

        encaminhar_fila_outro (adicao) { 
            if ( this.comunicando ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Encaminhar",
                    detail: "Aguarde a finalização da comunicação anterior.",
                    life: 3000
                });
                return;
            }
            
            this.comunicando = true;

            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'encaminhar_fila_outro',
                dados: { 
                    id_marcacao: this.value.id_marcacao, 
                    id_recepcao_adicao: adicao.id_recepcao_adicao, 
                },
                final: () => { 
                    this.comunicando = false;
                }
            });
        },

        fechar_modal () { 
            $('#' + this.nome_modal).modal('hide');
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        etiqueta_servidor_impressao(reimprimir = false) {
            this.amostra_selecionada = null;
            this.servidor_selecionado = 0;
            this.servidor_impressao = null;
            this.servidor_impressao_reimprimir = reimprimir;

            let serv = this.$util.getCookie('lab_servidor_impressao'); 

            if( serv ){

                // console.log('Info', this.$store.state.options);

                if ( this.$store.state.options['rota_etqs.index'] && this.$store.state.options['rota_etqs.index'].length ) { 
                    //console.log('Sim', this.$store.state.options['rota_etqs.index'].length);
                    this.exibir_rotas = true;
                } else { 
                    //console.log('Não');
                    this.exibir_rotas = false;
                }

                this.lista_servidor = serv.split(',');
                this.lista_servidor.push('Nenhum');
                this.lista_selecionadas = [];
                
                $('#etiquetaServidorImpressao' + this.sufixo_modal).modal('show');

            } else {

                this.block_enviadas = false;

                if(reimprimir)
                    this.reimprimir();
                else
                    this.abrir();

            }
        },

        etiqueta_servidor_impressao_fechar(visualizar = true) {

            $('#etiquetaServidorImpressao' + this.sufixo_modal).modal('hide');
            if(!visualizar && this.$util.getCookie('lab_servidor_impressao')) {
                this.servidor_impressao = this.$util.getCookie('lab_servidor_impressao');
            } else {
                this.servidor_impressao = null;
            }

            if(this.servidor_impressao_reimprimir)
                this.reimprimir();
            else
                this.abrir();
        },

        abrir(sem_pre = false) {
            if ( !sem_pre && this.pre_integracao ) {
                this.pre_integracao(this.abrir);
                return;
            }

            if ( this.comunicando ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Integração/Etiqueta",
                    detail: "Aguarde a finalização da comunicação anterior.",
                    life: 3000
                });
                return;
            }

            this.comunicando = true;

            let serv;

            if ( this.lista_servidor && this.lista_servidor.length ) { 
                serv = _.get(this.lista_servidor, this.servidor_selecionado);
            } else { 
                serv = this.servidor_impressao;
            }

            if ( this.tipo_etq && serv ) { 
                this.$util.setCookie('lab-etq-tipo', this.tipo_etq);    
            }

            this.$util.setCookie('lab-etq-rota', this.id_rota_etq ? this.id_rota_etq : "");

            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "etiquetas",
                redir_api: true,
                dados: {
                    id_marcacao: this.value.id_marcacao,
                    servidor_impressao: serv ? ( ( this.horabase && this.apenas_atualizadas ) ? 'Nenhum' : serv ) : null,
                    id_rota_etq: this.servidor_impressao_reimprimir ? '' : this.id_rota_etq, 
                    block_enviadas: this.block_enviadas, 
                    tipo_etq: this.tipo_etq,
                    // in_qtde: this.in_qtde,
                },
                callback: res => {
                    if ( !Array.isArray(res) ) {
                        res = [res];
                    }

                    let tem_erro = res.find(item => item && ( item.status == 'ERRO' || item.status == 'ERROR' ) );

                    res.forEach(item => {

                        if (item.status == "SUCESSO") {
                            let marcacao = this.value;

                            if (item.logins) {
                                marcacao.terceiro_logins = item.logins;
                                this.$emit("input", marcacao);
                            }

                            if (item.st_id_externo) {
                                marcacao.st_id_externo = item.st_id_externo;
                                this.$emit("input", marcacao);
                            }

                            if ( item.entregas && item.entregas.length ) {
                                if ( marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos ) {
                                    marcacao.atendimento.atendimento_procedimentos.forEach(atp => {
                                        let entrega = item.entregas.find(entrega => entrega.id_atendimento_procedimento == atp.id_atendimento_procedimento);
                                        if ( entrega ) {
                                            atp.dt_entrega = entrega.dt_entrega;

                                            if ( entrega.terc ) { 
                                                if ( !atp.js_solics ) { 
                                                    atp.js_solics = { terc: entrega.terc };
                                                } else { 
                                                    atp.js_solics.terc = entrega.terc;
                                                }
                                            }
                                        }
                                    });
                                }
                            }

                            if (item.warnings && item.warnings.length) {
                                item.warnings.forEach(warning => {
                                    this.$toast.add({
                                        severity: "warn",
                                        summary: item.nome_terceiro ? item.nome_terceiro : "Atualizar",
                                        detail: warning,
                                        life: 10000
                                    });
                                });
                            }

                            if (item.mensagem) {
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Atualizar",
                                    detail: item.mensagem,
                                    life: 3000
                                });
                            }

                            if (item.msg) {
                                this.$toast.add({
                                    severity: "success",
                                    summary: item.nome_terceiro ? item.nome_terceiro : "Atualizar",
                                    detail: item.msg,
                                    life: 3000
                                });
                            } else {

                                if ( this.horabase && this.apenas_atualizadas ) { 
                                    this.comunicando = false;
                                    this.reimprimir();
                                    return;
                                }

                                this.$emit("emitida");

                                if ( !tem_erro && item.resposta ) {

                                    if(this.servidor_impressao){
                                        this.$toast.add({
                                            severity: "success",
                                            summary: "Atualizar",
                                            detail: 'Etiqueta enviada para o servidor de impressão',
                                            life: 3000
                                        });
                                        return;
                                    }

                                    let pdfWindow = window.open("");
                                    pdfWindow.document.write(
                                        "<html><head><title>" + item.nome_terceiro +
                                            " - Etiqueta de Amostra</title></head><body><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                                            encodeURI(item.resposta) +
                                            "'></iframe></body></html>"
                                    );

                                }
                            }
                        } else {

                            if ( !item.mensagem && item.msg && Array.isArray(item.msg) ) {

                                item.msg.forEach(msg => {

                                    let msg_exibir = ( msg && msg.msg ) ? msg.msg : msg;

                                    this.$toast.add({
                                        severity: item.status == "INFO" ? "info" : "error",
                                        summary: ( item.nome_terceiro ? item.nome_terceiro : "Integração/Etiqueta" ),
                                        detail: msg_exibir,
                                        life: 30000
                                    });

                                })

                            } else {

                                let msg_exibir = item.mensagem ? item.mensagem : item.msg;

                                if ( msg_exibir.msg ) { 
                                    msg_exibir = msg_exibir.msg;
                                }

                                this.$toast.add({
                                    severity: item.status == "INFO" ? "info" : "error",
                                    summary: ( item.nome_terceiro ? item.nome_terceiro : "Integração/Etiqueta" ),
                                    detail: msg_exibir,
                                    life: 30000
                                });

                            }
                        }

                    });
                },
                final: () => {
                    this.comunicando = false;
                }
            });
        },
        reimprimir() {
            if ( this.comunicando ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Reimprimir Etiquetas",
                    detail: "Aguarde a finalização da comunicação anterior.",
                    life: 3000
                });
                return;
            }

            this.comunicando = true;

            let serv;
            let amostra;

            if ( this.lista_servidor && this.lista_servidor.length ) { 
                serv = _.get(this.lista_servidor, this.servidor_selecionado);
            } else { 
                serv = this.servidor_impressao;
            }

            /*
            if ( this.amostra_selecionada || this.amostra_selecionada === 0 ) { 
                amostra = _.get(this.lista_amostras, this.amostra_selecionada);

                if ( !amostra ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Imprimir",
                        detail: "Falha na identificação da amostra: " + this.amostra_selecionada,
                        life: 3000
                    });
                    return;
                }
            }
            */

           let amostras_selecs = this.lista_selecionadas.filter(amostra => amostra)
                .map(amostra => amostra.st_codigo);

            if ( this.tipo_etq && serv ) { 
                this.$util.setCookie('lab-etq-tipo', this.tipo_etq);    
            }

            this.$util.setCookie('lab-etq-rota', this.id_rota_etq ? this.id_rota_etq : "");

            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "reimprimir_etiquetas",
                redir_api: true,
                dados: {
                    id_marcacao: this.value.id_marcacao,
                    servidor_impressao: serv ? serv : null,
                    block_enviadas: this.block_enviadas,
                    id_amostra: amostra ? amostra.id_amostra : null, 
                    codigos: amostras_selecs, 
                    tipo_etq: this.tipo_etq,
                    horabase: ( this.horabase && this.apenas_atualizadas ) ? this.horabase : null, 
                    id_rota_etq: this.servidor_impressao_reimprimir ? '' : this.id_rota_etq,
                    etiqueta_extra: this.etiqueta_extra ? true : false,
                    in_qtde: this.in_qtde,
                },
                callback: res => {
                    if ( !Array.isArray(res) ) {
                        res = [res];
                    }

                    res.forEach(item => {
                        if (item.status == "SUCESSO") {
                            if (item.msg) {
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Atualizar",
                                    detail: item.msg,
                                    life: 3000
                                });
                            } else {

                                if(this.servidor_impressao){
                                     this.$toast.add({
                                        severity: "success",
                                        summary: "Atualizar",
                                        detail: 'Etiqueta enviada para o servidor de impressão',
                                        life: 3000
                                    });
                                    return;
                                }


                                let pdfWindow = window.open("");
                                pdfWindow.document.write(
                                    "<html><head>" +
                                        "<title>" + item.nome_terceiro + " - Etiqueta de Amostra</title></head><body>" +
                                        "<iframe title='Teste' width='100%' height='100%' src='data:application/pdf;base64, " +
                                        encodeURI(item.resposta) +
                                        "'></iframe></body></html>"
                                );
                            }
                        } else {
                            this.$toast.add({
                                severity: item.status == "INFO" ? "info" : "error",
                                summary: "Integração/Etiqueta",
                                detail: item.mensagem ? item.mensagem : item.msg,
                                life: 3000
                            });
                        }

                    });
                },
                final: () => {
                    this.comunicando = false;
                }
            });
        },

        exibir_log() {
            if (
                this.value &&
                this.value.atendimento &&
                this.value.atendimento.id_atendimento
            ) {
                this.$refs.terceiroLogRef.exibir_log(
                    this.value.atendimento.id_atendimento
                );
            }
        }
    },

    mounted() { 
        this.sufixo_modal = this.uuidv4();

        let id_rota_etq = this.$util.getCookie('lab-etq-rota');

        this.id_rota_etq = id_rota_etq ? id_rota_etq : '';

        let tipo = this.$util.getCookie('lab-etq-tipo');    

        this.tipo_etq = tipo ? tipo : 'P';    
    }
};
</script>
